// extracted by css-extract-rspack-plugin
module.exports =  {"response-item":"ResponseItem-hbPC__response-item","response-label":"ResponseItem-DCz8__response-label"};